exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/quote-settings/customers/create-edit-customer-modal/create-edit-customer-modal.component.css
// module id = 749
// module chunks = 0